import script from "./ImpersonateBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImpersonateBar.vue?vue&type=script&setup=true&lang=ts"

import "./ImpersonateBar.vue?vue&type=style&index=0&id=d5a9e65a&lang=postcss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5a9e65a"]])

export default __exports__